// Edit this file when you ship a change worth telling users about.
//
// Add a new entry at the TOP of the array (newest first). Each entry needs:
//   id      — unique string, never reused (used as the localStorage marker)
//   date    — YYYY-MM-DD, shown next to the title
//   title   — short headline
//   summary — 1–3 sentences, plain text. Line breaks render as paragraph breaks.
//
// The dot badge appears on the News button when news[0].id !== the user's
// stored lastSeen marker. So bumping the top entry's id is what triggers the
// "new!" indicator. Don't reuse old ids.
//
// First-time visitors are silently caught up to the latest entry — they don't
// see a badge for items shipped before they arrived.

const news = [
    {
        id: '2026-08-31-bots-got-personalities',
        date: '2026-08-31',
        title: 'The bots found their personalities',
        summary:
            "The five AI players are no longer clones of each other. Aimo is the " +
            "laid-back veteran, Aija chats and cheers you on, Aila is here to win, " +
            "Raimo says two words a day, and Maija finds every drawing delightful. " +
            "They also got a brain upgrade and should guess quite a bit better now.",
    },
    {
        id: '2026-08-26-bots-play-each-other',
        date: '2026-08-26',
        title: 'The AI bots keep the lights on',
        summary:
            "When nobody else is around, the AI players now start their own " +
            "Easy Words game instead of waiting in an empty lobby. Feel free to " +
            "drop in on them — they'll start guessing and chatting the moment a " +
            "real person joins, and they'll head your way if you open a room of " +
            "your own.",
    },
    {
        id: '2026-08-25-gallery-keeps-drawings',
        date: '2026-08-25',
        title: 'Gallery drawings no longer expire',
        summary:
            "Saved drawings used to be deleted after 90 days, which quietly wiped " +
            "out old all-time favourites. That's gone — drawings now stay forever. " +
            "If the gallery ever gets too big, only the oldest drawings with no " +
            "upvotes are cleared out; anything people liked is kept for good.",
    },
    {
        id: '2026-05-09-ai-bots-can-draw',
        date: '2026-05-09',
        title: 'AI bots can now draw',
        summary:
            "When it's their turn, AI bots now sketch the word themselves " +
            "instead of sitting it out. Expect simple marker-style doodles — " +
            "see if you can guess them faster than the other bots.",
    },
    {
        id: '2026-05-09-accent-matching',
        date: '2026-05-09',
        title: 'More forgiving guesses',
        summary:
            "Accents and diacritics no longer trip up the matcher — typing 'pina' " +
            "now counts as 'piña', 'cafe' as 'café', and so on. Custom wordsets " +
            "in any script (Tagalog, Spanish, Cyrillic, CJK…) work end-to-end.",
    },
    {
        id: '2026-05-08-server-stability',
        date: '2026-05-08',
        title: 'Server stability fixes',
        summary:
            "Tracked down a crash that could take rooms offline mid-game and " +
            "hardened the input handling all around. Drawing should feel the " +
            "same — just less likely to drop you.",
    },
];

export default news;
